import type { RootState } from 'state';
import type { DataCitiesState } from '../slice';

function getDataCitiesCountryCode(state: RootState): DataCitiesState['countryCode'] {
  const { countryCode } = state.dataService.dataCities;
  return countryCode;
}

export default getDataCitiesCountryCode;
